import { useState, useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import ChatPanel from './ChatPanel';
import ReportIssue from '../ReportIssue';
import { getPendingCount } from '../../api/replies';

export default function MainLayout() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [chatVisible, setChatVisible] = useState(false);
  const [chatCollapsed, setChatCollapsed] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [inboxCount, setInboxCount] = useState(0);
  const pollRef = useRef(null);

  useEffect(() => {
    const fetchCount = () => {
      getPendingCount().then(r => setInboxCount(r.total || 0)).catch(() => {});
    };
    fetchCount();
    pollRef.current = setInterval(fetchCount, 10000);
    return () => clearInterval(pollRef.current);
  }, []);

  const toggleSidebar = () => setSidebarCollapsed(prev => !prev);
  const toggleChat = () => setChatVisible(prev => !prev);
  const toggleChatCollapse = () => setChatCollapsed(prev => !prev);

  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar collapsed={sidebarCollapsed} onToggle={toggleSidebar} onReportIssue={() => setReportOpen(true)} inboxCount={inboxCount} />

      <div
        className={`transition-all duration-200 ${
          chatCollapsed ? '' : 'lg:mr-[380px]'
        } ${
          sidebarCollapsed ? 'lg:ml-16' : 'lg:ml-64'
        }`}
      >
        <TopBar onMenuClick={toggleSidebar} onChatToggle={toggleChat} onChatCollapse={toggleChatCollapse} chatCollapsed={chatCollapsed} />
        <main className="p-4 lg:p-6">
          <Outlet />
        </main>
      </div>

      <ChatPanel visible={chatVisible} onClose={() => setChatVisible(false)} collapsed={chatCollapsed} onToggleCollapse={toggleChatCollapse} />
      <ReportIssue open={reportOpen} onClose={() => setReportOpen(false)} />
    </div>
  );
}
